import { CategoricalDonut } from '../../Common/Charts/CategoricalDonut';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

export const ProceduresByModality = () => {
    const { chartData } = useProceduresChartsDataContext();

    const porModalidade = chartData?.byModality || [];
    const subtitles = porModalidade.map((item) => item.descricao);
    const values = porModalidade.map((item) => item.total);
    const colors = subtitles.map((_, index) => coresMescladasArray[index % coresMescladasArray.length]);

    return (
        <CategoricalDonut
            title={'Atendimentos por Modalidade'}
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};
